var map = {
	"./ARG.png": 2632,
	"./AUS.png": 193,
	"./BEL.png": 4489,
	"./BRA.png": 5071,
	"./CAN.png": 6722,
	"./CMR.png": 1495,
	"./CRC.png": 6695,
	"./CRO.png": 2679,
	"./DEN.png": 9022,
	"./ECU.png": 9215,
	"./ENG.png": 4126,
	"./ESP.png": 9368,
	"./FRA.png": 1487,
	"./GER.png": 760,
	"./GHA.png": 1201,
	"./IRN.png": 9898,
	"./JPN.png": 6876,
	"./KOR.png": 4861,
	"./KSA.png": 4607,
	"./MAR.png": 8970,
	"./MEX.png": 8760,
	"./NED.png": 7491,
	"./POL.png": 7350,
	"./POR.png": 7387,
	"./QAT.png": 8465,
	"./SEN.png": 6315,
	"./SRB.png": 7763,
	"./SUI.png": 5414,
	"./TUN.png": 3825,
	"./URU.png": 8598,
	"./USA.png": 9976,
	"./WAL.png": 1771,
	"./select.png": 7673
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1676;